import React, { useEffect, useRef } from "react";
import { PawPrint } from "lucide-react";

export default function PawCursor() {
  const cursorRef = useRef(null);
  const position = useRef({ x: -100, y: -100 });
  const current = useRef({ x: -100, y: -100 });
  const frame = useRef(null);

  useEffect(() => {
    const handleMouseMove = (event) => {
      position.current.x = event.clientX;
      position.current.y = event.clientY;
    };

    const animate = () => {
      current.current.x +=
        (position.current.x - current.current.x) * 0.22;

      current.current.y +=
        (position.current.y - current.current.y) * 0.22;

      if (cursorRef.current) {
        cursorRef.current.style.transform = `translate3d(
          ${current.current.x}px,
          ${current.current.y}px,
          0
        ) translate(-50%, -50%)`;
      }

      frame.current = requestAnimationFrame(animate);
    };

    window.addEventListener("mousemove", handleMouseMove, {
      passive: true,
    });

    frame.current = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);

      if (frame.current) {
        cancelAnimationFrame(frame.current);
      }
    };
  }, []);

  return (
    <div ref={cursorRef} className="paw-cursor" aria-hidden="true">
      <PawPrint className="paw-cursor-icon" strokeWidth={2.4} />
    </div>
  );
}
